// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"NI-z","smallCardRow":"OI-z","largeCardRow":"PI-z","productSearchRow":"QI-z","curatedRow":"RI-z"};